import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { SharedModule } from './shared/shared.module';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { TrackComponent } from './track/track.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CheckoutComponent } from './shopping-cart/checkout/checkout.component';
import { OrderconfirmationComponent } from './orderconfirmation/orderconfirmation.component';
import { LoginRegComponent } from './login-reg/login-reg.component';
import { BasicAuthInterceptor } from './_interceptor/basic-auth.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ComponentsModule } from './components/components.module';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainLayoutComponent,
    ShoppingCartComponent,
    TrackComponent,
    ContactUsComponent,
    CheckoutComponent,
    OrderconfirmationComponent,
    LoginRegComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgSelectModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    ComponentsModule
  ],
  providers: [
    // AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicAuthInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
